module.exports = __webpack_public_path__ + "static/media/imagemColetoresLogistica.d66e4ceb.png";